var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-blank",style:({'height': (parseInt(_vm.unitData.height) || 0) / 2 + 'px'})},[_vm._v("分割留白 ("+_vm._s(parseInt(_vm.unitData.height) || 20)+"px)")])
}
var staticRenderFns = []

export { render, staticRenderFns }